import React, { useEffect, useState } from "react";
import {
  doc,
  getDocs,
  updateDoc,
  collection,
  getDoc,
  query,
  where,
} from "firebase/firestore";
import { db, auth } from "../../../firebaseConfig";
import NavBar from "../NavBar";
import TiptapEditor from "../TipTap/SimpleTiptap";
import AddElement from "../AddElement";
import FlexmonsterComponent from "../Flexmonster/FlexmonsterTable";
import "./CreateNew.css";

function CreateNew() {
  const [editors, setEditors] = useState([]);
  const [components, setComponents] = useState([]);
  const [componentIdIncrement, setComponentIdIncrement] = useState(0);
  const [tableData, setTableData] = useState([]);

  const handleTableDataParsed = (tableData) => {
    // Use this data with Flexmonster or for other purposes
  };

  const handleGeminiData = (data) => {
    console.log("Data received in CreatePage:", data);
    setGeminiData(data);
  };
  const handleCreateVisualization = (jsonData) => {
    setTableData(jsonData);
  };

  const addNewEditor = () => {
    const newId = componentIdIncrement + 1;
    const newComponent = {
      type: "text-editor",
      id: `component-${newId}`,
      content: "<p>Start writing here...</p>",
    };
    setComponents([...components, newComponent]);
    setComponentIdIncrement(newId);
  };

  useEffect(() => {
    const fetchEditors = async () => {
      const querySnapshot = await getDocs(
        collection(db, "userID-001", "views", "viewID-001")
      );
      const fetchedEditors = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        content: doc.data().Content,
      }));
      setEditors(fetchedEditors);
    };

    fetchEditors();
  }, []);

  //=========== Fetch Existing Components and Determine the Highest ID
  useEffect(() => {
    const fetchExistingComponents = async () => {
      if (!auth.currentUser) {
        console.error("No authenticated user found.");
        return;
      }

      const userUID = auth.currentUser.uid;
      const viewsCollectionRef = collection(db, "views");
      const q = query(viewsCollectionRef, where("createdBy", "==", userUID));

      try {
        const querySnapshot = await getDocs(q);
        const fetchedComponents = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data().Content,
        }));
        setComponents(fetchedComponents);
        // Find the highest component ID to continue the sequence
        const maxId = fetchedComponents.reduce(
          (max, comp) => Math.max(max, parseInt(comp.id.split("-")[1] || 0)),
          0
        );
        setComponentIdIncrement(maxId);
      } catch (error) {
        console.error("Error fetching components:", error);
      }
    };

    fetchExistingComponents();
  }, []);
  return (
    <div>
      <NavBar />
      <AddElement
        onClick={addNewEditor}
        defaultMenuOpen={true}
        tableData={tableData}
      />

      <div style={{ height: "50vh" }}></div>
    </div>
  );
}

export default CreateNew;
